import { gql, useMutation } from '@apollo/client'
import { useToast } from 'components/Dashboard/Toast'
import SubmitButton from 'components/SubmitButton'
import TextInput from 'components/TextInput'
import { Form, Formik } from 'formik'
import { resultHistoryFragment } from './ResultHistory'
import { AddResultNoteMutation, AddResultNoteMutationVariables } from './__generated__/AddResultNoteMutation'

const addResultNoteMutation = gql`
  mutation AddResultNoteMutation($input: AddResultNoteInput!) {
    addResultNote(input: $input) {
      success
      message
      result {
        id
        ...ResultHistoryFragment
      }
    }
  }

  ${resultHistoryFragment}
`

interface FormValues {
  note: string
}

interface AddNoteToResultModalProps {
  resultId: string
  onRequestClose: () => void
}

const AddNoteToResultModal = ({ resultId, onRequestClose }: AddNoteToResultModalProps) => {
  const [addResultNote] = useMutation<AddResultNoteMutation, AddResultNoteMutationVariables>(addResultNoteMutation)

  const { addToast } = useToast()

  return (
    <Formik<FormValues>
      initialValues={{ note: '' }}
      onSubmit={async (values, { setStatus }) => {
        try {
          const resp = await addResultNote({
            variables: {
              input: {
                id: resultId,
                note: values.note,
              },
            },
          })

          if (!resp.data.addResultNote.success) {
            throw new Error(resp.data.addResultNote.message || 'Something went wrong')
          }

          onRequestClose()
          addToast({
            messageType: 'success',
            title: 'Success',
            content: <>Note added</>,
            timeout: 5000,
          })
        } catch (err) {
          setStatus({ error: err.message })
        }
      }}
    >
      {({ isSubmitting, status }) => (
        <Form>
          <TextInput name="note" label="Note" />

          <div className="buttons is-right mt-5">
            <SubmitButton className="is-primary" submitting={isSubmitting} disabled={isSubmitting}>
              Add Note
            </SubmitButton>
          </div>
          {status?.error && (
            <article className="message is-danger">
              <div className="message-body">Failed: {status.error}</div>
            </article>
          )}
        </Form>
      )}
    </Formik>
  )
}

export default AddNoteToResultModal
